'use strict';

function CompanyTimestampsService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/timestamps/:timestampId', {}, {
    'update': {
      method: 'PUT'
    },
    'queryTotalTime': {
			url: config.apiBase + '/companies/:companyId/timestamps/sum',
			method: 'GET'
    },
    'queryWorkTime': {
      url: config.apiBase + '/companies/:companyId/timestamps/worktime',
      method: 'GET',
      isArray: true
    }
  });
}

angular.module('dokiv')
  .factory('CompanyTimestampsService', ['$resource', 'config', CompanyTimestampsService]);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/timestamps/CompanyTimestampsService.js
// module id = 44
// module chunks = 0